export default "__VITE_ASSET__DQ27OKA$__"